import { FadeIn } from './AnimateIn'
import NavbarItem from './NavbarItem'
import { Text } from './Text'

interface Props {
  url: string
  onClick: () => void
  children: string
  index: number
}

export default function NavbarMenuItem({ url, onClick, children, index }: Props) {
  return (
    <FadeIn className='w-full' animateFrom='top' duration={0.2} delay={0.05 * index}>
      <NavbarItem
        url={url}
        className='w-full justify-start bg-opacity-5 text-primary'
        onClick={onClick}
      >
        <Text.H4>{children}</Text.H4>
      </NavbarItem>
    </FadeIn>
  )
}
